import React, { useState } from "react";
import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from "reactstrap";
import { WarningCards, Href, Warning } from "../../../../../Constant";
import { H6, LI } from "../../../../../AbstractElements";

export const WarningCard = () => {
  const [open, setOpen] = useState(false);
  const toggle = () => setOpen(!open);
  return (
    <div className="btn-group">
      <Dropdown isOpen={open} toggle={toggle}>
        <DropdownToggle caret color="warning" className="text-white">
          {WarningCards}
        </DropdownToggle>
        <DropdownMenu className="dropdown-block p-3 dark-form">
          <LI>
            <H6 className="fs-6 fw-bold pb-2">{Warning}</H6>
            <DropdownItem className="dropdown-item p-0 helper-truncate" href={Href}>Please! Check your notifications.</DropdownItem>
          </LI>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
